import { render, staticRenderFns } from "./ArticleUpload.vue?vue&type=template&id=472f3185"
import script from "./ArticleUpload.vue?vue&type=script&lang=js"
export * from "./ArticleUpload.vue?vue&type=script&lang=js"
import style0 from "./ArticleUpload.vue?vue&type=style&index=0&id=472f3185&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports